var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1547_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 59.0625C46.0508 59.0625 59.0625 46.0508 59.0625 30C59.0625 13.9492 46.0508 0.9375 30 0.9375C13.9492 0.9375 0.9375 13.9492 0.9375 30C0.9375 46.0508 13.9492 59.0625 30 59.0625Z",
    fill: "#712CB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3227 47.3206C50.6122 43.6918 47.0927 40.7452 43.0438 38.715C38.995 36.6848 34.5284 35.6269 29.9991 35.6255C25.4697 35.624 21.0025 36.679 16.9524 38.7066C12.9022 40.7342 9.38079 43.6785 6.66797 47.3056C9.36692 50.9511 12.8825 53.9135 16.9329 55.9552C20.9832 57.9969 25.4557 59.0612 29.9915 59.0626C34.5274 59.0641 39.0005 58.0027 43.0522 55.9636C47.1039 53.9245 50.6214 50.9643 53.3227 47.3206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 31.875C36.2132 31.875 41.25 26.8382 41.25 20.625C41.25 14.4118 36.2132 9.375 30 9.375C23.7868 9.375 18.75 14.4118 18.75 20.625C18.75 26.8382 23.7868 31.875 30 31.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1547_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrf);
export default __webpack_public_path__ + "static/media/prf.69bf4a2b25e67d8843651c5409c0f1bc.svg";
export { ForwardRef as ReactComponent };